import * as Factory from 'factory.ts'
import faker from 'faker'

import { type SpendingCardStatementAvailableMonth } from '@webapp/models/SpendingCardStatementAvailableMonth'

export const SpendingCardStatementAvailableMonthMock =
  Factory.Sync.makeFactory<SpendingCardStatementAvailableMonth>({
    start: Factory.each(() => faker.date.past().toISOString()),
    end: Factory.each(() => faker.date.past().toISOString()),
  })
